export const buildYourDreamBagColors = {
  primary: '#f37021',
  secondary: '#f37021',
  textDark: '#f37021',
  textLight: '#FFF',
  error: '#FF5858',
  background: '#0C140C',
  disabled: '#97A3AD',
  'bydb-white': '#FFFFFF',
  'bydb-black': '#000000',
  'bydb-gray': '#3A3A3A',
  'bydb-green': '#f37021',
  'bydb-light-gray': '#C7C7C7',
}

export const greatestHitsColors = {
  primary: '#000000',
  secondary: '#003DA5',
  textDark: '#000000',
  textLight: '#FFFFFF',
  error: '#FF0000',
  background: '#FFFFFF',
  disabled: '#97A3AD',
}

export const ultimateCoachingTripColors = {
  primary: '#AFDFF9',
  secondary: '#5D8299',
  textDark: '#19325B',
  textLight: '#FFFFFF',
  error: '#FF0000',
  background: '#0B2439',
  disabled: '#97A3AD',
}
